import { cx } from "components/Graphs/utils";
import Spinner from "components/Graphs/InlineSpinner";
import React from "react";

export type BalanceStatusTone = "healthy" | "warning" | "critical";

export interface BalanceStatusIndicatorProps {
  tone?: BalanceStatusTone;
  isLoading?: boolean;
  className?: string;
}

const toneClasses: Record<BalanceStatusTone, string> = {
  healthy: "bg-green-500",
  warning: "bg-yellow-500",
  critical: "bg-red-500",
};

const toneLabels: Record<BalanceStatusTone, string> = {
  healthy: "Balance runway is healthy",
  warning: "Balance runway is getting low",
  critical: "Balance runway is critically low",
};

export const BalanceStatusIndicator: React.FC<BalanceStatusIndicatorProps> = ({
  tone,
  isLoading = false,
  className,
}) => {
  if (isLoading) {
    return (
      <span
        className={cx(
          "inline-flex size-3 items-center justify-center",
          className,
        )}
        role="status"
        aria-label="Calculating balance runway"
      >
        <Spinner className="size-3" />
      </span>
    );
  }

  if (!tone) return null;

  return (
    <span
      className={cx("relative inline-flex size-2 shrink-0", className)}
      role="status"
      aria-label={toneLabels[tone]}
    >
      <span
        className={cx(
          "absolute inline-flex size-full animate-ping rounded-full opacity-50 motion-reduce:animate-none",
          toneClasses[tone],
        )}
        aria-hidden="true"
      />
      <span
        className={cx(
          "relative inline-flex size-2 rounded-full",
          toneClasses[tone],
        )}
        aria-hidden="true"
      />
    </span>
  );
};

BalanceStatusIndicator.displayName = "BalanceStatusIndicator";

export default BalanceStatusIndicator;
